export default __webpack_public_path__ + "assets/images/stop.622da719d8f3423725e16d093eebe5e2.svg";